import { collection, doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";

const GetUserByID = async (UserID) => {
  try {
    const UsersCollection = collection(db, "Users");
    const UserDocument = doc(UsersCollection, UserID);
    const UserSnapshot = await getDoc(UserDocument);

    let User = { ...UserSnapshot.data(), id: UserSnapshot.id };

    return User;
  } catch (error) {
    console.log(error);
  }
};

export default GetUserByID;
